<template>
    <div class="origIntroduct">
      <div class="operation_top">
          <topTit :titUrl='titUrl'></topTit>
      </div>
      <div class="origIntroduct_main">
        <div v-html="moduleCont"></div>
      </div>
    </div>
  </template>
  <script>
  import topTit from '../components/qiuanshangtong/head/header.vue'
  import { getCurrentInstance, reactive, toRefs,watch } from 'vue'
  import { useRoute,useRouter } from 'vue-router';
  export default{
    name:"richTtext",
    components: {
      topTit
    },
    setup(){
      const {proxy}=getCurrentInstance();
      const route=useRoute();
      const router=useRouter();
      let initData=reactive({
        commenUrl:proxy.commenUrl,
        moduleUrl:"ENTPPORTALMODULECONTENT_LIST",
        moduleId:route.query.id,
        moduleType:route.query.moduleType,
        moduleCont:""
      });
      function imgSrcReplace(htmlstr) {
        let regex3 = new RegExp(/<img [^>]*attr-src=['"]([^'>]+)[^>]*>/gi);
        let htmlstr1 = htmlstr.replace(regex3, function (match, capture) {
          console.log("capture:", capture);
          let tmp3 = capture.replace('"', "").replace(/[\\]/g, "");
          let tmp1 = tmp3.split("style=");
          let tmp2 = tmp3.split(" ");
          console.log(tmp2,"tmp3")
          // capture = capture;
          var newStr =
            "<video src=" +
            tmp2[0] +
            ' controls="controls" alt="" style=' +
            tmp1[tmp1.length - 1] +
            '" ></video>';
          return newStr;
        });
        regex3 = null;
        return htmlstr1;
      }
      function imgSrcReplace1(htmlstr) {
        let regex3 = new RegExp(/<img [^>]*src=['"]([^'>]+)[^>]*>/gi);
        let htmlstr1 = htmlstr.replace(regex3, function (match, capture) {
          let tmp3 = capture.replace('"', "").replace(/[\\]/g, "");
          let tmp2 = tmp3.split(" ");
          let tmp4 = "";
          let arrnum=""
          tmp2.map((item, index) => {
            if(item.indexOf("width") != -1){
              arrnum++
            }
          });
          tmp2.map((item, index) => {
              if(arrnum<=1){
                if (item.indexOf("width") != -1 && item.indexOf("style") == -1&&item.indexOf("width:")==-1) {
                  tmp4 = item;
                }
              }
          });
          if (tmp4) {
            tmp4 = tmp4.split("=");
            let temp5 = tmp4[1].slice(1, tmp4[1].length - 1);
            let temp6 = `width:${temp5}px`;
            var newStr =
              "<img src=" + tmp2[0] + " alt='' style='" + temp6 + "' ></img>";
            return newStr;
          } else {
            let capture1 =capture.replace('"', "").replace(/[\\]/g, "");
            var newStr ="<img src=" + capture1 + " alt=''></img>";
            return newStr;
          }
        });
        return htmlstr1;
      }
      function moduleFindInfo(){//点击除‘基地云图 基地vr 基地视频’三个以外的模块
        let url="ENTPPORTALMODULEMAGE_FINDINFO";
        proxy.$request({
          url: url,
          method: "post",
          data: {
            id:route.query.id,
          },
        }).then((res) => {
          if (res.data.code == "000") {
            let result=res.data.result;
            let videohtml=imgSrcReplace(result.moduleCont);
            initData.moduleCont=imgSrcReplace1(videohtml);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
      watch(() => router.currentRoute.value.query,() => {
        moduleFindInfo();
      },{immediate: true,deep: true});
      const titUrl = "全球商通中心运营支撑体系";
      return{
        titUrl,
        initData,
        ...toRefs(initData)
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .origIntroduct{
    background: url(../images/qiuanshangtong/bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height:100vh;
    overflow: hidden;
    :deep(img){
      max-width: 100%;
    }
    :deep(video){
      max-width: 100%;
    }
  
    @media only screen and (max-width: 768px) {
      /* For mobile phones: */
     
    }
    .operation_top{
      position: fixed;
      height:15vh;
      width:100vw;
    }
    .origIntroduct_main{
      padding-top: 15vh;
      height: 100vh;
      overflow: scroll;
    }
    /* 整个滚动条 */
    ::-webkit-scrollbar {
      width: 10px;  /* 垂直滚动条宽度 */
      height: 10px; /* 水平滚动条高度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
      background: #f1f1f1; /* 轨道背景色 */
      border-radius: 5px;  /* 圆角 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
      background: #a0c4e6; /* 浅蓝色滑块 */
      border-radius: 5px;  /* 圆角 */
    }

    /* 鼠标悬停在滑块上时的样式 */
    ::-webkit-scrollbar-thumb:hover {
      background: #7fb0d8; /* 稍深的浅蓝色 */
    }

    /* 滚动条角落（水平和垂直滚动条交汇处） */
    ::-webkit-scrollbar-corner {
      background: #f1f1f1;
    }
  }
  </style>